export default {
    'diagram4-1-2': {
        's': 'S = Believe entrepreneurs succeed either because they plan carefully or bet long odds',
        's-a': 'S = Believe Xs succeed because of A or B',
        'c': ' C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
        'c-a': 'C = But Xs do neither A nor B',
        'q': 'Q = How do they succeed?',
        'q-a': 'Q = How do Xs succeed?',
        'a': 'A = They blend two contradictory skills: careful analytical thinking and a willingness to push boundaries.',
        'a-a': 'A = They blend contradictory skills',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/4/4a/diagram2/i18n/en.js